import { render, staticRenderFns } from "./ProductEditModal.vue?vue&type=template&id=6f54f6f3&scoped=true&"
import script from "./ProductEditModal.vue?vue&type=script&lang=js&"
export * from "./ProductEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f54f6f3",
  null
  
)

export default component.exports